import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	requiredField: {
		id: 'project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.required-field',
		defaultMessage: 'Required fields are marked with an asterisk.',
		description: 'The description text',
	},
	cancel: {
		id: 'project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.cancel',
		defaultMessage: 'Cancel',
		description: 'Button text to go to cancel the import',
	},
});
